<template>
  <v-select
    id="axis-select"
    v-model ="filter.encontroId"
    item-text ="grupoData"
    item-name ="encontroId"
    item-value ="encontroId"
    :items="meetings"
    label ="Evento"
    placeholder ="Evento"
    v-on:change ="$emit('onChange', meetings, filter.encontroId)"
    :disabled = "disabled"
  >
    <template slot="no-data">
      Nenhum Evento retornado
    </template>
  </v-select>
</template>

<script>
import { meetingAPI } from '../API/MeetingAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppMeetingCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.loadMeetings()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadMeetings () {
      this.setLoading(true)
      meetingAPI.getByCitySemRelatorio(this.filter.municipioId)
        .then(resp => {
          this.meetings = resp.data
          this.setLoading(false)
        })
        .catch(this.setLoading(false))
    }
  },
  data () {
    return {
      meetings: []
    }
  }
}
</script>
